import { GithubOutlined } from '@ant-design/icons';
import { DefaultFooter } from '@ant-design/pro-components';
import React from 'react';

const Footer: React.FC = () => {

  // <>Powered by <a href="https://elot.jellykite.com" target='_blank'>ELOT</a></>
  return (
    <DefaultFooter
      style={{
        background: 'none',
      }}
      copyright={
        'Powered by ELOT'
      }
    />
  );
};

export default Footer;
